import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AccountComponent} from './account/account.component';
import {ApplicationPipesModule} from '../../application-pipes-module/application-pipes.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PasswordPromptComponent} from './account/password-prompt/password-prompt.component';
import {UserCollectionsComponent} from './user-collections/user-collections.component';
import {
  MatAutocompleteModule,
  MatCardModule,
  MatDatepickerModule,
  MatDividerModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatOptionModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
} from '@angular/material';
import {UserCollectionComponent} from './user-collections/user-collection/user-collection.component';
import {RouterModule} from '@angular/router';
import {UserItemDeletePromptComponent} from './user-item-delete-prompt/user-item-delete-prompt.component';
import {FavouriteButtonComponent} from './user-collections/favourite-button/favourite-button.component';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {UserQueriesComponent} from './user-queries/user-queries.component';
import {UserQueryComponent} from './user-queries/user-query/user-query.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ApplicationPipesModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatCardModule,
    MatProgressSpinnerModule,
    RouterModule,
    FormsModule,
    MatAutocompleteModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatIconModule,
    MatListModule,
    MatDividerModule,
  ],
  exports: [FavouriteButtonComponent],
  declarations: [AccountComponent, PasswordPromptComponent, UserCollectionsComponent, UserCollectionComponent, UserItemDeletePromptComponent, FavouriteButtonComponent, UserQueriesComponent, UserQueryComponent],
  providers: []
})
export class AccountModule {
}
